import styled from 'styled-components';

import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';

export const Wrapper = styled.div<{ height: number, hasBorderRadius: boolean }>`
    height: ${({ height }) => height ? `${height}px` : '30px'};
    align-items: center;
    &:not(:last-child) {
        margin-right: 4px;
    }

    img {
        height: ${({ height }) => height ? `${height}px` : '30px'};
        width: auto;
        border-radius: ${({ hasBorderRadius }) => hasBorderRadius ? BorderRadius.labelRadius : 'none' };
    }
`;
